import React from 'react';

import { Consumer } from 'components/Banner/HeroBanner/HeroWrapper/HeroWrapper';
import ActionIcon from 'elements/ActionIcons/ActionIcon';

import styles from './TypeC.css';

const TypeC = () => (
  <Consumer>
    {
      ({ playVideo }) => (
        <div className={styles.wrapper}>
          <div className={styles.rectangle}>
            {
              playVideo &&
                <ActionIcon customClasses={styles.actionIcon} icon="play" type="30" onClick={playVideo} />
            }
          </div>
        </div>
      )
    }
  </Consumer>
);

TypeC.displayName = 'TypeC';

export default TypeC;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/TypeC/TypeC.js